import React, { useContext } from 'react';
import { Button } from 'antd';

import OrganizationContactsContext from '@totem/components/settings/sections/contacts/contactsContext';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const ContactsHeaderActions = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { onAction } = useContext(OrganizationContactsContext);

  return (
    <>
      {permissions.systemAdministrator.hasPermissions(userProfile) && (
        <Button
          type="primary"
          onClick={() =>
            onAction('EditContact', {
              id: '',
              name: '',
              email: '',
              phone: '',
              labels: [],
            })
          }
        >
          Add Contact
        </Button>
      )}
    </>
  );
};

export default ContactsHeaderActions;
